// extracted by mini-css-extract-plugin
export default {"agencyReviewsEmptyListForTheYear":"agencyReviewsEmptyListForTheYear_W0CqO","title":"title_dR2q3","description":"description_NRKQ7","buttonContainer":"buttonContainer_Nr0ct"};